import axiosInstance from "../../../api/axiosInstance";
import { getCountryFromUrl, constructBookingUrl } from './urlUtils';
import { processWorkspaceOptions, extractLocationOptions, extractRateOptions } from './dataProcessingUtils';

/**
 * Fetches user data and previous bookings count
 * @returns {Promise<Object>} Object containing booking count, userName, and lastBookedSpace
 */
export const fetchUserDataAndBookings = async () => {
    try {
        console.log('Chatbot: Making API call to booking/userData...');
        const response = await axiosInstance.get('booking/userData');
        console.log('Chatbot: API response received:', response);

        if (response.data !== undefined && response.data !== null) {
            const userData = response.data;
            console.log('Chatbot: Raw API data:', userData);

            const result = {
                bookingCount: userData.completedBookingCount || 0,
                userName: userData.userName || '',
                lastBookedSpace: userData.lastBookedSpace || null
            };

            console.log('Chatbot: Processed user data:', result);
            return result;
        }
        console.log('Chatbot: No data in response, returning default values');
        return { bookingCount: 0, userName: '', lastBookedSpace: null };
    } catch (error) {
        console.error('Chatbot: Error fetching user data:', error);
        console.error('Chatbot: Error details:', {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data
        });
        return { bookingCount: 0, userName: '', lastBookedSpace: null };
    }
};

// Fetches workspace options from API
export const fetchWorkspaceOptions = async (country = 'LK') => {
    try {
        const [activitiesResponse, eventTypeResponse] = await Promise.all([
            axiosInstance.get(`space/space-activities?country=${country}`),
            axiosInstance.get(`space/event-type-map?country=${country}`)
        ]);

        if (activitiesResponse.data && Array.isArray(activitiesResponse.data)) {
            const options = processWorkspaceOptions(activitiesResponse.data, eventTypeResponse.data);

            return {
                success: true,
                options: options,
                hasOptions: options.length > 0
            };
        }

        return {
            success: false,
            options: [],
            hasOptions: false,
            error: 'Invalid response format'
        };
    } catch (error) {
        console.error('Error fetching workspace options:', error);
        return {
            success: false,
            options: [],
            hasOptions: false,
            error: error.message || 'Failed to fetch workspace options'
        };
    }
};

// Searches for available spaces based on criteria
export const searchAvailableSpaces = async (searchParams) => {
    try {
        const { category, country, eventType, x, y } = searchParams;

        const searchResponse = await axiosInstance.get(
            `search/map?category=${category}&country=${country}&eventType=${eventType}&x=${x}&y=${y}`
        );

        if (!searchResponse.data || !Array.isArray(searchResponse.data)) {
            throw new Error('Invalid search response format');
        }

        const spaces = searchResponse.data;

        // Extract rate and location options using utilities
        const dynamicRateOptions = extractRateOptions(spaces);
        const { locationOptions: dynamicLocationOptions } = extractLocationOptions(spaces);

        return {
            success: true,
            spaces: spaces,
            rateOptions: dynamicRateOptions,
            locationOptions: dynamicLocationOptions,
            hasLocations: dynamicLocationOptions.length > 0
        };

    } catch (error) {
        console.error('Error searching for spaces:', error);
        return {
            success: false,
            spaces: [],
            rateOptions: [],
            locationOptions: [],
            hasLocations: false,
            error: error.message || 'Failed to search for spaces'
        };
    }
};


